/** Helper to check if a user role can view as another client */
export function canViewAsClient(role: string | undefined): boolean {
  return role === "trainer" || role === "admin" || role === "coach";
}
